<div class="score-bar-block">
    <div
        class="score-bar"
        [ngClass]="{ 'score-success': score >= 0.66, 'score-warning': score < 0.66, 'score-danger': score < 0.33 }">
        <div class="score" [ngStyle]="{ width: scoreLength }"></div>
    </div>
    <div class="score-value">{{ scoreLength }}</div>
</div>
